import React from 'react';
import { CheckCircleIcon, StarIcon } from '@heroicons/react/24/solid';

const HeroSection = () => {
  return (
    <section className="py-6 sm:py-10">
      <div className="max-w-3xl mx-auto px-4">
        <div className="space-y-5 sm:space-y-6">
          
          {/* Simple Tag */}
          <span className="inline-block px-3 py-1 text-xs font-medium text-indigo-600 bg-indigo-50 rounded-full">
            Pune • Doorstep Service
          </span>
          
          {/* Minimal Heading */}
          <h1 className="text-3xl sm:text-5xl font-bold text-gray-900 leading-tight">
            Professional<br/>Bike Services
          </h1>
          
          <p className="text-sm sm:text-base text-gray-600 max-w-md">
            Expert repairs & maintenance with genuine parts at your doorstep.
          </p>

          {/* Inline Benefits */}
          <div className="flex flex-wrap gap-3">
            <div className="flex items-center gap-1.5">
              <CheckCircleIcon className="h-4 w-4 text-green-500" />
              <span className="text-xs sm:text-sm text-gray-700">Free Pickup</span>
            </div>
            <div className="flex items-center gap-1.5">
              <CheckCircleIcon className="h-4 w-4 text-green-500" />
              <span className="text-xs sm:text-sm text-gray-700">Certified Techs</span>
            </div>
            <div className="flex items-center gap-1.5">
              <CheckCircleIcon className="h-4 w-4 text-green-500" />
              <span className="text-xs sm:text-sm text-gray-700">Genuine Parts</span>
            </div>
          </div>

          {/* Compact Rating */}
          <div className="flex items-center gap-3 text-sm">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <StarIcon key={i} className="h-4 w-4 text-yellow-400" />
              ))}
            </div>
            <span className="font-medium text-gray-900">4.9</span>
            <span className="text-gray-500">• 5000+ customers</span>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
